export default {
    alertTitle: '系统提示',
    appName: document.title,
    appVersion: '2.1',
    appUpdate: '2019-03-25 10:37:00',
}




// WEBPACK FOOTER //
// ./src/config/app-config.js